import { c as _c } from "react/compiler-runtime";
import { useEffect, useState } from 'react';
import { useLocalStorage } from '@bridge/ui';
const DISMISSED_KEY_PREFIX = 'dashboard-alert-dismissed';
export const SESSION_DISMISSED_KEY_PREFIX = 'dashboard-alert-session-dismissed';

/**
 * Manages dismiss state for dashboard alerts.
 *
 * - Dismissing hides the alert for the current browser window/tab (sessionStorage).
 * - Each dismiss increments a persistent counter (localStorage).
 * - Once the counter reaches maxDismissals the alert is permanently hidden.
 */
export function useDashboardAlertDismiss(alertId, maxDismissals) {
  const $ = _c(10);
  const [totalDismissCount, setTotalDismissCount] = useLocalStorage(`${DISMISSED_KEY_PREFIX}-${alertId}`, 0);
  const [dismissedThisSession, setDismissedThisSession] = useState(false);
  let t0;
  let t1;
  if ($[0] !== alertId) {
    t0 = () => {
      if (sessionStorage.getItem(`${SESSION_DISMISSED_KEY_PREFIX}-${alertId}`) === "true") {
        setDismissedThisSession(true);
      }
    };
    t1 = [alertId];
    $[0] = alertId;
    $[1] = t0;
    $[2] = t1;
  } else {
    t0 = $[1];
    t1 = $[2];
  }
  useEffect(t0, t1);
  const isPermanentlyDismissed = totalDismissCount >= maxDismissals;
  const isDismissed = isPermanentlyDismissed || dismissedThisSession;
  let t2;
  if ($[3] !== alertId || $[4] !== setTotalDismissCount) {
    t2 = () => {
      setDismissedThisSession(true);
      sessionStorage.setItem(`${SESSION_DISMISSED_KEY_PREFIX}-${alertId}`, "true");
      setTotalDismissCount(_temp);
    };
    $[3] = alertId;
    $[4] = setTotalDismissCount;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  const dismiss = t2;
  let t3;
  if ($[6] !== dismiss || $[7] !== isDismissed || $[8] !== totalDismissCount) {
    t3 = {
      isDismissed,
      dismiss,
      totalDismissCount
    };
    $[6] = dismiss;
    $[7] = isDismissed;
    $[8] = totalDismissCount;
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  return t3;
}
function _temp(prev) {
  return typeof prev === "number" ? prev + 1 : 1;
}